import { navLinks } from "@/mocks/homeData";

export default function Footer() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "奇妙漫画网",
    url: "https://mangoselect.github.io/",
    description: "精选短篇漫画、脑洞短篇、创意短篇的在线阅读平台，奇思妙想创意短篇在线速看。",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "hello@qimiao-mh.example",
    },
  };

  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2"
              aria-label="奇妙漫画网首页"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-palette-line text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                奇妙漫画网
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              精选短篇漫画、脑洞短篇、创意短篇，题材丰富、节奏紧凑、短小精悍却回味无穷。通勤摸鱼，都能看完一篇。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-tiktok-line", label: "抖音" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#subscribe"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#subscribe")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="font-heading text-base text-foreground-950">
              栏目导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .querySelector(link.href)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base text-foreground-950">
              联系我们
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" />
                <a
                  href="mailto:hello@qimiao-mh.example"
                  className="transition-colors hover:text-primary-600"
                >
                  hello@qimiao-mh.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" />
                每日更新 · 随时可读
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-heart-3-line text-primary-600" />
                脑洞短篇 · 创意速读
              </li>
            </ul>
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector("#subscribe")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              订阅新作
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-200 pt-6 text-center sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 奇妙漫画网 · 用心讲好每一个短篇故事
          </p>
          <p className="text-xs text-foreground-600">
            奇思妙想 · 脑洞短篇 · 创意速读
          </p>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </footer>
  );
}